// Loader.js
import React, { useEffect, useState } from "react";
import { Backdrop } from "@mui/material";
import { subscribeToLoading, getIsLoading } from "../../services/loaderService";
import loadingGif from "../../assets/animations/loading-panel-kodo.gif";

export const Loader = () => {
  const [showBackdrop, setshowBackdrop] = useState(getIsLoading());

  useEffect(() => {
    // subscribe to the changes of isLoading
    const unsubscribe = subscribeToLoading((newLoadingState) => {
      setshowBackdrop(newLoadingState);
    });

    return () => {
      unsubscribe();
    };
  }, []);

  return (
    <Backdrop
      open={showBackdrop}
      sx={{
        zIndex: "1000",
        backdropFilter: "blur(5px)",
        background: "rgba(0, 0, 0, 0.125)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <img
        src={loadingGif}
        alt="Loading..."
        style={{
          width: "4rem",
          height: "4rem",
          objectFit: "contain",
        }}
      />
    </Backdrop>
  );
};
